import React, { useContext, useEffect } from "react";
import useForm from "../../hooks/useForm";
import { useMutation } from "@apollo/client";
import gql from "graphql-tag";
import { isNil, cloneDeep } from "lodash";
import { SnackbarContext } from "../../context/snackbarContext";
import { FetchContext } from "../../context/fetchContext";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import PlanPill from "../../components/PlanPill/PlanPill";

const initErrorForm = {};

const EditDialog = ({ open, handleClose, planId, initForm }) => {
  const { snack } = useContext(SnackbarContext);
  const { requestFetch } = useContext(FetchContext);
  const [updatePlan] = useMutation(UPDATE_PLAN);
  const { form, formErrors, handleChange, handleChangeDate, resetForm, validateForm } = useForm({
    initForm,
    initErrorForm,
  });

  const handleChangeUseDepartmentTheme = () => {
    const clonedForm = cloneDeep(form);
    clonedForm.useDepartmentTheme = !form.useDepartmentTheme;
    resetForm(clonedForm);
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const { departmentName, useDepartmentTheme, theme, color, shortName } = form;

    try {
      const ok = await updatePlan({
        variables: {
          id: planId,
          departmentName,
          useDepartmentTheme,
          theme,
          color,
          shortName,
        },
      });

      if (ok.data.updateSinglePlan) {
        requestFetch();
        snack(`Successfully updated ${form.departmentName} department`);
        handleClose();
      }
    } catch (err) {
      snack("Failed to update plan details", "error");
    }
  };

  useEffect(() => {
    resetForm(initForm);
  }, [initForm]);

  const isCorporate = isNil(initForm.departmentName) || form.departmentName === "Corporate";

  return (
    <Dialog
      open={open}
      fullWidth
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
    >
      <DialogTitle>Edit 1 Year Department {initForm.departmentName && `(${initForm.departmentName})`}</DialogTitle>
      <DialogContent>
        {/* <TextField
          label="Department Name"
          name="departmentName"
          fullWidth
          variant="outlined"
          margin="normal"
          value={isCorporate ? "Corporate" : form.departmentName || ""}
          onChange={handleChange}
          disabled={isCorporate}
        /> */}
        <TextField
          label="Department Theme"
          name="theme"
          fullWidth
          variant="outlined"
          margin="normal"
          value={form.theme || ""}
          onChange={handleChange}
          helperText={formErrors.theme}
          error={Boolean(formErrors.theme)}
          disabled={isCorporate ? false : !form.useDepartmentTheme}
          InputProps={
            isCorporate
              ? {}
              : {
                  endAdornment: (
                    <Button
                      variant={form.useDepartmentTheme ? "contained" : "outlined"}
                      onClick={handleChangeUseDepartmentTheme}
                      color="primary"
                      disableElevation
                    >
                      {form.useDepartmentTheme ? "Enabled" : "Disabled"}
                    </Button>
                  ),
                }
          }
        />
        {/* <DatePicker
          views={["year"]}
          fullWidth
          autoOk
          variant="inline"
          inputVariant="outlined"
          format="yyyy"
          margin="normal"
          label="Plan Year"
          value={form.year || ""}
          onChange={handleChangeDate("year")}
        /> */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <TextField
            label="Short Name"
            name="shortName"
            variant="outlined"
            margin="normal"
            value={(form.shortName || "").toUpperCase()}
            onChange={handleChange}
            fullWidth
            disabled={isCorporate}
          />
          <TextField
            type="color"
            onChange={handleChange}
            value={form.color || "#000000"}
            name="color"
            helperText={formErrors.color}
            error={Boolean(formErrors.color)}
            label="Color"
            margin="normal"
            variant="outlined"
            fullWidth
            style={{ marginLeft: "0.5rem" }}
          />
          <PlanPill plan={{ departmentName: form.departmentName, color: form.color, shortName: form.shortName }} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDialog;

const UPDATE_PLAN = gql`
  mutation ($id: ID!, $theme: String, $departmentName: String, $useDepartmentTheme: Boolean, $color: String, $shortName: String) {
    updateSinglePlan(
      id: $id
      theme: $theme
      departmentName: $departmentName
      useDepartmentTheme: $useDepartmentTheme
      color: $color
      shortName: $shortName
    )
  }
`;
